// Carry Roll Decision support — compare, hazard, recommend (10.1–10.6, 7.8). Pure functions.
import { simulate } from './simulate';
import { handicapDispersion } from './diagnostics';
import { mToYd } from './units';
/** Compare scenarios side by side (10.1, 7.4). Distance values in the active unit. */
export function compareScenarios(scenarios, distanceUnit = 'm') {
    const results = scenarios.map((s) => ({ s, r: simulate(s.request) }));
    const conv = (m) => (distanceUnit === 'yd' ? Math.round(mToYd(m)) : Math.round(m));
    const metrics = [
        {
            metric: `Carry (${distanceUnit})`,
            values: results.map((x) => conv(x.r.carryM).toString()),
        },
        {
            metric: `Total (${distanceUnit})`,
            values: results.map((x) => conv(x.r.totalM).toString()),
        },
        {
            metric: `Roll (${distanceUnit})`,
            values: results.map((x) => conv(x.r.rollM).toString()),
        },
        {
            metric: 'Roll %',
            values: results.map((x) => `${Math.round(x.r.rollPercent * 100)}%`),
        },
        {
            metric: 'Apex (m)',
            values: results.map((x) => Math.round(x.r.apexM).toString()),
        },
        {
            metric: 'Shape',
            values: results.map((x) => x.r.shotShape),
        },
    ];
    return metrics;
}
/** Dispersion-aware finish zone (7.8). Returns the lateral and downrange spread. */
export function dispersionFinishZone(result, handicap) {
    const dispersion = handicapDispersion(handicap);
    const lateralSpreadM = dispersion;
    // Downrange spread ≈ 70% of lateral for typical golfers
    const downrangeSpreadM = dispersion * 0.7;
    return {
        centerM: Math.round(result.totalM),
        lateralSpreadM: Math.round(lateralSpreadM),
        downrangeSpreadM: Math.round(downrangeSpreadM),
        zoneDescription: `Expected finish zone: ${Math.round(result.totalM)} m ± ${Math.round(downrangeSpreadM)} m, ± ${Math.round(lateralSpreadM)} m lateral (Hcap ${handicap}).`,
    };
}
//# sourceMappingURL=compare.js.map